import GuestPanel from './GuestPanel.jsx';

export default GuestPanel;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/GuestInput/GuestPanel/index.js